/**
  * Whether the experience in Fiverr is business or not
  *
  * @param url
  * @returns {boolean}
  */
export const isBusinessExperience = (url) => {
    const subdomains = (new URL(url)).host.split('.');

    return subdomains.includes('business');
};
